import React from "react"

const MarketingConsentCheckbox = ({
  checked = false,
  setChecked = (val) => null,
  label = "I agree to receive occasional marketing emails from Workplace One. I can unsubscribe at any time.",
}) => {
  return (
    <div className={"my-3"}>
      <label htmlFor="consent" className={"form-label form-label-consent mb-0"}>
        <input
          type="checkbox"
          id={"consent"}
          checked={checked}
          onChange={(e) => {
            setChecked(e.target.checked)
          }}
        />
        <span>&#10003;</span> {label}
      </label>
    </div>
  )
}

export default MarketingConsentCheckbox
